import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter,Input } from 'reactstrap';
//Import Select Component
import Select from 'react-select';
import DatePicker from 'react-datepicker';

export default {
  RegisterModal:function(self){

    return(
      <Modal isOpen={self.state.RegisterModalShow} toggle={self.__ToogleRegisterModal__} className={'modal-lg ' + self.props.className}>
        <ModalHeader toggle={self.__ToogleRegisterModal__}>{'Add new asset'}</ModalHeader>
        <ModalBody>
        <div className="card-block">
          <div className="form-group">
            <label htmlFor="Tag">Tag</label>
            <input
              type="text"
              className="form-control"
              id="Tag"
              placeholder="Enter Asset Tag"
              onChange={(event)=> self.setState({Tag: event.target.value})}
            />
          </div>
          <div className="form-group">
            <label htmlFor="Name">Name</label>
            <input
              type="text"
              className="form-control"
              id="Name"
              placeholder="Enter Asset Name"
              onChange={(event)=> self.setState({Name: event.target.value})}
            />
          </div>
          <div className="form-group">
            <label htmlFor="street">Description</label>
            <textarea
              id="Description"
              name="Description"
              rows="5"
              className="form-control"
              placeholder="Enter Asset Description"
              onChange={(event)=> self.setState({Description: event.target.value})}
            ></textarea>
          </div>
          <div className="row">
            <div className="form-group col-sm-8">
              <label htmlFor="city">Serial Number</label>
              <input
                type="text"
                className="form-control"
                id="SerialNumber"
                placeholder="Enter Asset Serial Number"
                onChange={(event)=> self.setState({SerialNumber: event.target.value})}
                />
            </div>
            <div className="form-group col-sm-4">
              <label htmlFor="postal-code">Purchased Date</label>
              <DatePicker
                id="PurchasedDate"
                name="PurchasedDate"
                className="form-control"
                dateFormat="YYYY-MM-DD"
                selected={self.state.PurchasedDate}
                onChange={(val)=>self.__OnPurchasedDateChange__(val,self)}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-8">
              <label htmlFor="city">Purchase Order</label>
              <input type="text"
                className="form-control"
                id="PurchaseOrder"
                placeholder="Purchase Order"
                onChange={(event)=> self.setState({PurchaseOrder: event.target.value})}
              />
            </div>
            <div className="form-group col-sm-4">
              <label htmlFor="postal-code">Purchase Currency</label>
              <Input
                type="select"
                name="PurchaseCurrency"
                id="PurchaseCurrency"
                value={self.state.PurchaseCurrency}
                onChange={(event)=> self.setState({PurchaseCurrency: event.target.value})}
                >
                 {self.RenderHelper.RenderCurrenciesOption(self.props.CurrencyReducer)}
               </Input>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-8">
              <label htmlFor="city">Vendor Name</label>
              <Select.Creatable
                name="PurchaseVendorName"
                placeholder="Type Asset Vendor"
                value={self.state.PurchaseVendorName}
                options={self.RenderHelper.RenderMasterAutoComplete(self.props.VendorReducer)}
                onChange={(val)=>self.__HandleVendorChanged__(val,self.props.VendorReducer,self.props.RunRedux)}

              />
            </div>
            <div className="form-group col-sm-4">
              <label htmlFor="postal-code">Status</label>
              <Input
                type="select"
                name="Status"
                id="Status"
                onChange={(event)=> self.setState({Status: event.target.value})}
                >
                 {self.RenderHelper.RenderMasterOption(self.props.AssetStatusReducer)}
               </Input>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-8">
            <label htmlFor="postal-code">Purchase Price</label>
            <input
              type="number"
              className="form-control"
              id="PurchasePrice"
              placeholder="Purchase Price"
              onChange={(event)=> self.setState({PurchasePrice: event.target.value})}
              />
            </div>
            <div className="form-group col-sm-4">
              <label htmlFor="city">Type</label>
              <Input
                type="select"
                name="Type"
                id="Type"
                onChange={(event)=> self.setState({Type: event.target.value})}
                >
                 {self.RenderHelper.RenderMasterOption(self.props.AssetTypeReducer)}
               </Input>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12">
            </div>

          </div>
        </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={self.__ToogleRegisterModal__}>Cancel</Button>
          <Button color="primary" onClick={()=>self.__Save__()}>Save</Button>{' '}
        </ModalFooter>
      </Modal>
    )
  },
  DeleteModal:function(self){
    return(
      <Modal isOpen={self.state.DeleteModalShow} toggle={self.__ToogleDeleteModal__} className={'modal-lg ' + self.props.className}>
        <ModalHeader toggle={self.__ToogleDeleteModal__}>{'Delete asset'}</ModalHeader>
        <ModalBody>
        <div className="card-block">
          <div>
            {"Are you sure want to delete "+self.state.Name+" from your asset?"}
          </div>
        </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={self.__ToogleDeleteModal__}>Cancel</Button>
          <Button color="danger" onClick={()=>self.__Delete__()}>Delete</Button>{' '}
        </ModalFooter>
      </Modal>
    )
  },
  UpdateModal:function(self){
    return(
      <Modal isOpen={self.state.UpdateModalShow} toggle={self.__ToogleUpdateModal__} className={'modal-lg ' + self.props.className}>
        <ModalHeader toggle={self.__ToogleUpdateModal__}>{'Edit asset'}</ModalHeader>
        <ModalBody>
        <div className="card-block">
          <div className="form-group">
            <label htmlFor="Tag">Tag</label>
            <input
              type="text"
              className="form-control"
              id="Tag"
              placeholder="Enter Asset Tag"
              value={self.state.ActiveUpdate.Tag}
              onChange={(event)=> self.setState({ActiveUpdate: {...self.state.ActiveUpdate,Tag:event.target.value}})}
            />
          </div>
          <div className="form-group">
            <label htmlFor="Name">Name</label>
            <input
              type="text"
              className="form-control"
              id="Name"
              placeholder="Enter Asset Name"
              value={self.state.ActiveUpdate.Name}
              onChange={(event)=> self.setState({ActiveUpdate: {...self.state.ActiveUpdate,Name:event.target.value}})}
            />
          </div>
          <div className="form-group">
            <label htmlFor="street">Description</label>
            <textarea
              id="Description"
              name="Description"
              rows="5"
              className="form-control"
              placeholder="Enter Asset Description"
              value={self.state.ActiveUpdate.Description}
              onChange={(event)=> self.setState({ActiveUpdate: {...self.state.ActiveUpdate,Description:event.target.value}})}
            ></textarea>
          </div>
          <div className="row">
            <div className="form-group col-sm-8">
              <label htmlFor="city">Serial Number</label>
              <input
                type="text"
                className="form-control"
                id="SerialNumber"
                placeholder="Enter Asset Serial Number"
                value={self.state.ActiveUpdate.SerialNumber}
                onChange={(event)=> self.setState({ActiveUpdate: {...self.state.ActiveUpdate,SerialNumber:event.target.value}})}
                />
            </div>
            <div className="form-group col-sm-4">
              <label htmlFor="postal-code">Purchased Date</label>
              <DatePicker
                id="PurchasedDate"
                name="PurchasedDate"
                className="form-control"
                dateFormat="YYYY-MM-DD"
                selected={self.state.ActiveUpdate.PurchasedDate}
                onChange={(val)=>self.__OnUpdatePurchasedDateChange__(val,self)}
                value={self.state.ActiveUpdate.PurchasedDate}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-8">
              <label htmlFor="city">Purchase Order</label>
              <input type="text"
                className="form-control"
                id="PurchaseOrder"
                placeholder="Purchase Order"
                value={self.state.ActiveUpdate.PurchaseOrder}
                onChange={(event)=> self.setState({ActiveUpdate: {...self.state.ActiveUpdate,PurchaseOrder:event.target.value}})}
              />
            </div>
            <div className="form-group col-sm-4">
              <label htmlFor="postal-code">Purchase Currency</label>
              <Input
                type="select"
                name="PurchaseCurrency"
                id="PurchaseCurrency"
                value={self.state.ActiveUpdate.PurchaseCurrency}
                onChange={(event)=> self.setState({ActiveUpdate: {...self.state.ActiveUpdate,PurchaseCurrency:event.target.value}})}
                >
                 {self.RenderHelper.RenderCurrenciesOption(self.props.CurrencyReducer)}
               </Input>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-8">
              <label htmlFor="city">Vendor Name</label>
              <Select.Creatable
                name="Update-PurchaseVendorName"
                placeholder="Type Asset Vendor"
                options={self.RenderHelper.RenderMasterAutoComplete(self.props.VendorReducer)}
                onChange={(val)=>self.__HandleUpdateVendorChanged__(val,self.props.VendorReducer,self.props.RunRedux)}
                value={self.state.ActiveUpdate.PurchaseVendorName}

              />
            </div>
            <div className="form-group col-sm-4">
              <label htmlFor="postal-code">Status</label>
              <Input
                type="select"
                name="Status"
                id="Status"
                value={self.state.ActiveUpdate.Status}
                onChange={(event)=> self.setState({ActiveUpdate: {...self.state.ActiveUpdate,Status:event.target.value}})}
                >
                 {self.RenderHelper.RenderMasterOption(self.props.AssetStatusReducer)}
               </Input>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-8">
            <label htmlFor="postal-code">Purchase Price</label>
            <input
              type="number"
              className="form-control"
              id="PurchasePrice"
              placeholder="Purchase Price"
              value={self.state.ActiveUpdate.PurchasePrice}
              onChange={(event)=> self.setState({ActiveUpdate: {...self.state.ActiveUpdate,PurchasePrice:event.target.value}})}
              />
            </div>
            <div className="form-group col-sm-4">
              <label htmlFor="city">Type</label>
              <Input
                type="select"
                name="Type"
                id="Type"
                value={self.state.ActiveUpdate.Type}
                onChange={(event)=> self.setState({ActiveUpdate: {...self.state.ActiveUpdate,Type:event.target.value}})}
                >
                 {self.RenderHelper.RenderMasterOption(self.props.AssetTypeReducer)}
               </Input>
            </div>
          </div>
        </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={self.__ToogleUpdateModal__}>Cancel</Button>
          <Button color="primary" onClick={()=>self.__Update__()}>Save</Button>{' '}
        </ModalFooter>
      </Modal>
    )
  },
}



// WEBPACK FOOTER //
// ./src/App/asset/asset/helper/modal.js